import { isEmpty, isPlainObject } from 'lodash'

import { deleteStorageByKey, readFromStorageByKey, updateStorageByKey } from '@/utils/persist'

const AI_REPORT_DEBUG_SETTINGS_STORAGE_KEY = 'aiReportDebugSettings'

/*
 * The debug settings a person saves in the debug dialog, kept in the browser per Organization
 * until the person clears them (FR-0.8, FR-0.13) and sent with each Alignment generation of the
 * person (FR-0.14). They hold only the fields the person changed: a field left out takes its
 * configured value on the server (FR-0.7).
 */
export const useAiReportDebugSettings = () => {
  // the storage drops its entries after a week by default, the debug settings stay until cleared
  const readSettings = () => {
    const settings = readFromStorageByKey(AI_REPORT_DEBUG_SETTINGS_STORAGE_KEY, null, {
      ignoreTtl: true
    })

    return isPlainObject(settings) && !isEmpty(settings) ? settings : null
  }

  const clearSettings = () => {
    deleteStorageByKey(AI_REPORT_DEBUG_SETTINGS_STORAGE_KEY)
  }

  const saveSettings = async (settings = {}) => {
    if (isEmpty(settings)) {
      clearSettings()
      return
    }

    await updateStorageByKey(AI_REPORT_DEBUG_SETTINGS_STORAGE_KEY, settings)
  }

  return {
    readSettings,
    saveSettings,
    clearSettings
  }
}
